import {useContext} from 'react'

import {AccordionContext} from './AccordionContext'

export const useAccordion = () => {
  const context = useContext(AccordionContext)

  if (context === null) {
    throw new Error('Accordion component has to be placed inside Accordion')
  }

  return context
}
